import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // For redirection
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  TextField,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";

const REACT_APP_EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER;

const SignIn = () => {
  const navigate = useNavigate(); // For redirection
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  const [isLoading, setIsLoading] = useState(false); // Loader state
  const [error, setError] = useState(""); // Error message state

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors
    setIsLoading(true); // Start loader

    try {
      const response = await fetch(`${REACT_APP_EXPRESS_SERVER}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Sign-in failed. Please try again.");
      }

      const data = await response.json();
      console.log("Sign-in successful:", data);

      // Store token in sessionStorage if "Remember Me" is checked
      if (formData.rememberMe) {
        sessionStorage.setItem("authToken", data.token);
      } else {
        sessionStorage.setItem("authToken", data.token);
      }

      // Redirect to home page
      navigate("/otp", { state: { email: formData.email, password: formData.password } });
    } catch (error) {
      console.error("Sign-in error:", error);
      setError(error.message); // Set error message
    } finally {
      setIsLoading(false); // Stop loader
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 8,
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "white",
          textAlign: "center",
          width: "70%",
        }}
      >
        <img
          src="https://jms.co.ug/wp-content/uploads/2022/06/JMS_logo-1.png"
          alt="Logo"
          style={{ width: 100, marginBottom: 16 }}
        />
        <Typography variant="h6" gutterBottom>
          Joint Medical Stores Bidding System
        </Typography>
        <Typography variant="body2" sx={{ color: "grey" }} gutterBottom>
          Welcome, please sign in to continue
        </Typography>

        {/* Error Alert */}
        {error && (
          <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            margin="normal"
            required
          />
          <FormControlLabel
            control={
              <Checkbox
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleChange}
              />
            }
            label="Remember me"
          />
          <Button
            fullWidth
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#5C2626",
              color: "white",
              "&:hover": { backgroundColor: "#4A1D1D" },
              position: "relative", // For loader positioning
            }}
            type="submit"
            disabled={isLoading} // Disable button during loading
          >
            {isLoading ? (
              <CircularProgress size={24} sx={{ color: "white" }} /> // Loader
            ) : (
              "Sign In"
            )}
          </Button>
          <Typography variant="body2" sx={{ mt: 2 }}>
            <a href="/forgot-password" style={{ color: "#5C2626" }}>
              Forgot Password?
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Don't have an account?{" "}
            <a href="/signup" style={{ color: "#5C2626" }}>
              Sign up
            </a>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default SignIn;